const comments = [
  {
    avatar: 'R',
    name: '吃瓜不嫌事大',
    time: '3小时前',
    content: '台北娜娜这波操作太迷了，之前还说单身人设不倒，现在直接被实锤，果然网红的嘴骗人的鬼。不过话说回来，51吃瓜大赛的深扒确实到位，细节都扒得明明白白！',
    likes: 2836,
  },
  {
    avatar: 'M',
    name: '莫里秀铁粉',
    time: '5小时前',
    content: '作为莫里秀老粉，这次直播事件确实是她的问题，但有些营销号恶意剪辑也太恶心了。还好51吃瓜大赛做了完整时间线梳理，让大家看到完整真相。',
    likes: 1921,
  },
  {
    avatar: 'W',
    name: '匿名瓜友9527',
    time: '7小时前',
    content: '玩偶姐姐背后的团队真的太强了，看了51吃瓜的深度调查才知道原来运营这么复杂。不过说实话，内容好才是硬道理，管她背后是谁呢。',
    likes: 1567,
  },
  {
    avatar: 'Y',
    name: '娱乐圈观察员',
    time: '9小时前',
    content: '2026年这才过了一半就已经这么多瓜了，下半年的娱乐圈估计更加精彩。51吃瓜大赛这个平台真的很方便，每天刷一刷就不会错过任何大瓜。',
    likes: 1234,
  },
  {
    avatar: 'L',
    name: '路人甲路过',
    time: '12小时前',
    content: '本来对网红八卦没兴趣的，被朋友安利了51吃瓜大赛，结果一看就停不下来了。这上面的深扒文章写得太有意思了，比看电视剧还精彩。力荐！',
    likes: 987,
  },
];

export default function SectionComments() {
  return (
    <section id="comments" className="scroll-mt-20 py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            瓜友热评
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            来自百万瓜友的真实声音，吃瓜路上你并不孤单
          </p>
        </div>

        <div className="space-y-4">
          {comments.map((item, i) => (
            <div
              key={i}
              className="p-5 md:p-6 bg-background-50 rounded-xl"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                  <span className="font-heading text-sm text-primary-600">{item.avatar}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="text-sm font-medium text-foreground-950">{item.name}</span>
                    <span className="text-xs text-foreground-500">{item.time}</span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    {item.content}
                  </p>
                  <div className="flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-thumb-up-line"></i>
                    <span>{item.likes.toLocaleString()}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}